export const AltFieldComponents = [
    { display: 'Short Answer', value: 'input' },
    { display: 'Long Answer', value: 'textarea' },
    { display: 'Multiple Selection', value: 'radio' },
    { display: 'Picture Selection', value: 'picture-selection' },
    { display: 'Date', value: 'date' },
    { display: 'Checkbox', value: 'checkbox' },
    { display: 'Dropdown', value: 'select' },
    { display: 'Autocomplete Dropdown', value: 'autocomplete' },
    { display: 'Watch Video', value: 'video' },
    { display: 'Signature/Drawing', value: 'signature' },
    { display: 'List Answer', value: 'chip' },
    { display: 'File Upload', value: 'upload' },
    { display: 'Photo Upload', value: 'photo-upload' },
    { display: 'Linear', value: 'linear' },
    { display: 'Range', value: 'range' }
];
export const LAST_FIELD_KEY = 'alt-last-field';
//# sourceMappingURL=alt-field.js.map
